"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var apollo_link_ws_1 = require("apollo-link-ws");
var printer_1 = require("graphql/language/printer");
var url = require("url");
var apollo_link_context_1 = require("apollo-link-context");
var AWSSubscriptionClient_1 = require("./AWSSubscriptionClient");
var createAnonymousHttpLink = function (defaultGraphqlEndpoint, apiKey) {
    var host = url.parse(defaultGraphqlEndpoint).host;
    var header = generateSubscriptionHeaderAnonymous(apiKey, { host: host });
    return apollo_link_context_1.setContext(function (_, _a) {
        var headers = _a.headers;
        return {
            headers: __assign(__assign({}, headers), header)
        };
    });
};
exports.createAnonymousHttpLink = createAnonymousHttpLink;
var createUserpoolHttpLink = function (defaultGraphqlEndpoint, getJwtToken) {
    var host = url.parse(defaultGraphqlEndpoint).host;
    return apollo_link_context_1.setContext(function (_, _a) {
        var headers = _a.headers;
        var header = generateSubscriptionHeader(getJwtToken, { host: host });
        return {
            headers: __assign(__assign({}, headers), header)
        };
    });
};
exports.createUserpoolHttpLink = createUserpoolHttpLink;
var createWebsocketLink = function (customRealtimeEndpoint, defaultGraphqlEndpoint, getJwtToken) {
    // Too many issues were found when using the aws provided realtime-subscription-handshake-link and the library
    // is poorly maintained. Because of this we are opting to use the community driven WebSocketLink and add in
    // middleware that will allow us to authenticate properly into the appsync realtime endpoint.
    // we need to generate the header and payload query string based on how aws does it
    // https://github.com/awslabs/aws-mobile-appsync-sdk-js/blob/master/packages/aws-appsync-subscription-link/src/realtime-subscription-handshake-link.ts
    var host = url.parse(defaultGraphqlEndpoint).host;
    var middleware = {
        applyMiddleware: function (options, next) {
            if (options.query) {
                var header = generateSubscriptionHeader(getJwtToken, { host: host });
                options.data = JSON.stringify({
                    query: typeof options.query === 'string'
                        ? options.query
                        : printer_1.print(options.query),
                    variables: options.variables
                });
                options.extensions = {
                    authorization: __assign({}, header)
                };
            }
            next();
        }
    };
    var websocketUrl = getAppsyncWebSocketUrl(host, customRealtimeEndpoint, generateSubscriptionHeader.bind(generateSubscriptionHeader, getJwtToken));
    var subscription;
    var connectionCallback = function (message) {
        if (message) {
            var errors = message.errors;
            if (errors && errors.length > 0) {
                var error = errors[0];
                if (error) {
                    if (error.errorCode === 401) {
                        if (subscription) {
                            subscription.setUrl(getAppsyncWebSocketUrl(host, customRealtimeEndpoint, generateSubscriptionHeader.bind(generateSubscriptionHeader, getJwtToken)));
                            // reapply middleware to operation options since it could have
                            // an invalid token embedded in the options
                            for (var key in Object.keys(subscription.operations)) {
                                if (key) {
                                    var val = subscription.operations[key];
                                    if (val) {
                                        val.options = subscription.applyMiddlewares(val.options);
                                    }
                                }
                            }
                            // force close after a 401. this will auto-reconnect if reconnect = true
                            // on the client options
                            subscription.close(false, false);
                        }
                    }
                }
            }
        }
    };
    subscription = new AWSSubscriptionClient_1.AWSSubscriptionClient(websocketUrl, {
        reconnect: true,
        timeout: 5 * 60 * 1000,
        connectionCallback: connectionCallback
    });
    var wsLink = new apollo_link_ws_1.WebSocketLink(subscription);
    // @ts-ignore
    wsLink.subscriptionClient.use([middleware]);
    return wsLink;
};
exports.createWebsocketLink = createWebsocketLink;
var createAnonymousWebsocketLink = function (customRealtimeEndpoint, defaultGraphqlEndpoint, apiKey) {
    // Too many issues were found when using the aws provided realtime-subscription-handshake-link and the library
    // is poorly maintained. Because of this we are opting to use the community driven WebSocketLink and add in
    // middleware that will allow us to authenticate properly into the appsync realtime endpoint.
    // we need to generate the header and payload query string based on how aws does it
    // https://github.com/awslabs/aws-mobile-appsync-sdk-js/blob/master/packages/aws-appsync-subscription-link/src/realtime-subscription-handshake-link.ts
    var host = url.parse(defaultGraphqlEndpoint).host;
    var middleware = {
        applyMiddleware: function (options, next) {
            if (options.query) {
                var header = generateSubscriptionHeaderAnonymous(apiKey, { host: host });
                options.data = JSON.stringify({
                    query: typeof options.query === 'string'
                        ? options.query
                        : printer_1.print(options.query),
                    variables: options.variables
                });
                options.extensions = {
                    authorization: __assign({}, header)
                };
            }
            next();
        }
    };
    var websocketUrl = getAppsyncWebSocketUrl(host, customRealtimeEndpoint, generateSubscriptionHeaderAnonymous.bind(generateSubscriptionHeaderAnonymous, apiKey));
    var subscription;
    var connectionCallback = function (message) {
        if (message) {
            var errors = message.errors;
            if (errors && errors.length > 0) {
                var error = errors[0];
                if (error) {
                    if (error.errorCode === 401) {
                        if (subscription) {
                            subscription.setUrl(getAppsyncWebSocketUrl(host, customRealtimeEndpoint, generateSubscriptionHeaderAnonymous.bind(generateSubscriptionHeaderAnonymous, apiKey)));
                            // reapply middleware to operation options since it could have
                            // an invalid token embedded in the options
                            for (var key in Object.keys(subscription.operations)) {
                                if (key) {
                                    var val = subscription.operations[key];
                                    if (val) {
                                        val.options = subscription.applyMiddlewares(val.options);
                                    }
                                }
                            }
                            // force close after a 401. this will auto-reconnect if reconnect = true
                            // on the client options
                            subscription.close(false, false);
                        }
                    }
                }
            }
        }
    };
    subscription = new AWSSubscriptionClient_1.AWSSubscriptionClient(websocketUrl, {
        reconnect: true,
        timeout: 5 * 60 * 1000,
        connectionCallback: connectionCallback
    });
    var wsLink = new apollo_link_ws_1.WebSocketLink(subscription);
    // @ts-ignore
    wsLink.subscriptionClient.use([middleware]);
    return wsLink;
};
exports.createAnonymousWebsocketLink = createAnonymousWebsocketLink;
var generateSubscriptionHeader = function (getJwtToken, _a) {
    var host = _a.host;
    var Authorization;
    try {
        //Authorization = (await Auth.currentSession()).getAccessToken().getJwtToken();
        Authorization = getJwtToken();
    }
    catch (e) {
        console.error('user probably not logged in', e);
    }
    return {
        Authorization: Authorization,
        host: host
    };
};
var generateSubscriptionHeaderAnonymous = function (apiKey, _a) {
    var host = _a.host;
    console.log('use apiKey for host', apiKey, host);
    return {
        'x-api-key': apiKey,
        host: host
    };
};
var getAppsyncWebSocketUrl = function (internalGraphqlHost, realtimeEndpoint, generateHeader) {
    var headerObj = generateHeader({ host: internalGraphqlHost });
    var headerBase64 = Buffer.from(JSON.stringify(headerObj)).toString('base64');
    var payloadBase64 = Buffer.from('{}').toString('base64');
    var convertedRealtimeEndpoint = convertRealtimeEndpoint(realtimeEndpoint);
    var websocketUrl = convertedRealtimeEndpoint + "?header=" + headerBase64 + "&payload=" + payloadBase64;
    return websocketUrl;
};
var convertRealtimeEndpoint = function (endpoint) {
    return endpoint
        .replace('https://', 'wss://')
        .replace('appsync-api', 'appsync-realtime-api')
        .replace('gogi-beta', 'grt-beta');
};
